import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";

export interface IJackpotWidgetTitleBox {
  layout: JACKPOT_WIDGET_LAYOUT;
  widgetWidth: number;
  isDaily: boolean;
}

const handleTitleBoxFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number, mAndBelow: boolean = false) => {
  switch (layout) {
    case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
      /** In desktop view at a widget width of 468px, the title should be of font-size 35px */
      return widgetWidth * 35 / 468 + "px";
    case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
      /** In minimized view at a widget width of 375px, the title should be of font-size 25px */
      return widgetWidth * 25 / 375 + "px";
    case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
    default:
      if (mAndBelow) {
        /** In mobile view at a widget width of 131px, the title should be of font-size 14px */
        return widgetWidth * 14 / 131 + "px";
      } else {
        /** At a widget width of 240px, the title should be of font-size 25px */
        return widgetWidth * 25 / 240 + "px";
      }
  }
};

export const JackpotTitleDefaultBox = styled.div<IJackpotWidgetTitleBox>`
  display: none;
`;

export const JackpotTitleMrGreenBox = styled(JackpotTitleDefaultBox)`
  display: ${({isDaily}) => isDaily ? "block" : "none"};
  text-shadow: 0px 2.70px 2.70px rgba(0, 0, 0, 0.29);
  line-height: 1.2;
  text-align: center;
  ${({theme}) => theme.font.presets.bold};
  color: ${({theme}) => theme.colors.brandSecondaryLight};
  padding-top: 5%;

  font-size: ${({layout, widgetWidth}) => handleTitleBoxFontSize(layout, widgetWidth)};

  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    font-size: ${({layout, widgetWidth}) => handleTitleBoxFontSize(layout, widgetWidth, true)};
  }

`;

const JackpotTitleBox = styledByTheme(JackpotTitleDefaultBox)
    .forMrGreen(JackpotTitleMrGreenBox)
    .forMrGreenCip(JackpotTitleMrGreenBox)
    .forMrGreenCis(JackpotTitleMrGreenBox)
    .apply();

export default JackpotTitleBox;

